import getTransactionsOptions from 'api/v1/transactions/getTransactionsAsOptions';
import { Select } from 'components/atoms/Form/Select';
import type { SelectProps } from 'components/atoms/Form/Select/select.types';
import type { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { BankTransactionsCacheKeys } from 'types/cacheKeys.types';
import { Transaction } from 'types/transactions.types';
import { TransactionGroup, TransactionOption2 } from './utils';

interface PaymentLinkProps extends SelectProps {
  value?: string[] | null;
  renderSelected: (selectedOptions?: any[]) => ReactNode;
  suggestedTransactionOptions?: {
    queryFn: () => Promise<Transaction | null>;
    queryKey: any[];
    enabled: boolean;
  };
  isDisabled?: boolean;
}

const PaymentLink: FC<PaymentLinkProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Select
      cacheKey={BankTransactionsCacheKeys.PaymentLinkedList}
      key={props.name}
      mode="asyncOptionsPaginated"
      classNamePrefix="transactions"
      asyncSearch
      isMulti
      controlShouldRenderValue={false}
      isClearable={false}
      formatGroupLabel={(group: any) => (
        <TransactionGroup title={group.title} subTitle={group.subTitle} />
      )}
      formatOptionLabel={(option: any, context) => {
        if (context.context !== 'menu') return '';
        if (option.preset) {
          return (
            <TransactionOption2
              transaction={{ counterPartyName: option.label }}
            />
          );
        }
        return <TransactionOption2 transaction={option.transaction} />;
      }}
      placeholder={t('expense.link_payment.type_to_search')}
      onFetch={getTransactionsOptions}
      {...props}
      mapOptions={({ fixedOptions, options }) => {
        return [...fixedOptions, ...options];
      }}
    />
  );
};

export default PaymentLink;
